import { createContext, useContext, useState, useEffect } from 'react';
import { fetchWithRetry } from '../utils/api';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(() => {
        const t = localStorage.getItem('token');
        return (t === 'null' || t === 'undefined' || !t) ? null : t;
    });
    const [refreshToken, setRefreshToken] = useState(localStorage.getItem('refreshToken') || null);
    const [loading, setLoading] = useState(true);

    const API = import.meta.env.VITE_API_URL || 'https://octoink-backend.onrender.com';

    useEffect(() => {
        const savedUser = localStorage.getItem('user');
        if (savedUser && token) {
            try {
                setUser(JSON.parse(savedUser));
            } catch (e) {
                console.error("Failed to parse saved user:", e);
                localStorage.removeItem('user');
                setUser(null);
            }
        }
        setLoading(false);
    }, [token]);

    const login = async (email, password) => {
        try {
            const data = await fetchWithRetry(`${API}/api/auth/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password }),
            });
            
            if (data.success) {
                localStorage.setItem('token', data.token);
                localStorage.setItem('refreshToken', data.refreshToken);
                localStorage.setItem('user', JSON.stringify(data.user));
                setToken(data.token);
                setRefreshToken(data.refreshToken);
                setUser(data.user);
                return { success: true };
            }
            return { success: false, message: data.message };
        } catch (err) {
            return { success: false, message: err.message || 'Login failed' };
        }
    };

    const register = async (name, email, password) => {
        try {
            const data = await fetchWithRetry(`${API}/api/auth/register`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ name, email, password }),
            });
            
            if (data.success) {
                localStorage.setItem('token', data.token);
                localStorage.setItem('refreshToken', data.refreshToken);
                localStorage.setItem('user', JSON.stringify(data.user));
                setToken(data.token);
                setRefreshToken(data.refreshToken);
                setUser(data.user);
                return { success: true };
            }
            return { success: false, message: data.message };
        } catch (err) {
            return { success: false, message: err.message || 'Registration failed' };
        }
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user');
        setToken(null);
        setRefreshToken(null);
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, token, refreshToken, login, register, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};
